module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/bg-top-78934f65e79cd74df1b09585b722012e.png";